// How a feature declares its translator notes (translator/notes/<feature>.notes.ts, collected by
// translator/notes.ts with import.meta.glob). A note is one engine note id
// (`notes.add(text, id, args)` in engine/src): the names of its arguments in the order the strings
// take them, and its sentence in Finnish and English. Each notes file also adds its ids to
// `NoteIds` (module augmentation), so `NoteKey` stays the exact union of the ids the app knows.

/** One translator note in the UI languages. */
export interface NoteDef {
  /** The engine note's argument names (TranslationNote.args), in the order `fi` / `en` take them. */
  readonly args: readonly string[];
  readonly fi: (a: string[]) => string;
  readonly en: (a: string[]) => string;
}

/**
 * Every note id the app knows, as keys. Each notes file extends it:
 * `declare module '../note-defs' { interface NoteIds extends Record<keyof typeof notes, true> {} }`.
 */
export interface NoteIds {}

export type NoteKey = keyof NoteIds & string;

/** A feature's notes (typed: each sentence function takes the arguments as strings). */
export const defineNotes = <T extends Record<string, NoteDef>>(notes: T): T => notes;
